import React from 'react';
import classes from './Spinner.css';

const Spinner = (props) => (
    <div className={classes.Loader}>Loading...</div>
);

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js